"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs = {
    state: {
        primary: "bg-yellow-700 hover:bg-yellow-450 active:bg-yellow-400 text-gray-900",
        secondary: "border bg-white dark:bg-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-800 hover:border-blue-700 dark:hover:border-blue-200 focus:border-blue-700 dark:focus:border-blue-200",
        tertiary: "border text-gray-1000",
        disabled: "select-none relative border border-gray-400 bg-disabled text-gray-500 cursor-not-allowed",
        custom: "",
    },
    color: {
        link: "border border-transparent text-blue-700",
        info: "border border-transparent text-blue-700",
        success: "border border-green-700 hover:bg-green-300 active:border-green-400 text-green-700",
        warning: "border border-yellow-700 hover:bg-yellow-300 active:border-yellow-400 text-yellow-700",
        danger: "border border-red-700 hover:bg-red-300 active:border-red-400 text-red-700",
    },
    size: {
        sm: {
            text: "text-xs h-8",
            options: {
                textSize: "text-xs",
                box: {
                    inner: "w-2 h-2",
                    outer: "w-4 h-4",
                    rounded: "rounded",
                },
            },
        },
        md: {
            text: "text-sm h-10",
            options: {
                textSize: "text-sm",
                box: {
                    inner: "w-3 h-3",
                    outer: "w-6 h-6",
                    rounded: "rounded-lg",
                },
            },
        },
        lg: {
            text: "text-base h-12",
            options: {
                textSize: "text-lg",
                box: {
                    inner: "w-4 h-4",
                    outer: "w-8 h-8",
                    rounded: "rounded-xl",
                },
            },
        },
    },
};
exports.default = configs;
